import { GET_SEARCH_RESULTS, STACK_SEARCH_RESULTS, SEARCH_LOADER, RESET_SEARCH_RESULT, SAVE_HISTORY_STATE, GET_TOPIC_DATA, GET_SEARCH_SUGGESTIONS, GET_TOGGLE_DATA, ADD_SELECTED_ASSETS_PILLS_COLLECTION, GET_API_RESPONSE_STATUS } from '../../constants/reducerTypes';

const initialState = {
  searchResults: [],
  totalRows: 0,
  searchPage: 0,
  searchLoader: false
};
const searchResultsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: action.payload.results,
        totalRows: action.payload.totalRows,
        searchPage: 1,
        searchLoader: false
      };
    case STACK_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: state.searchResults.concat(action.payload.results),
        totalRows: action.payload.totalRows,
        searchPage: state.searchPage + 1,
        searchLoader: false
      };
    case SEARCH_LOADER:
      return {
        ...state,
        searchLoader: true
      };
    case SAVE_HISTORY_STATE:
      return {
        ...state,
        persistState: action.payload.previousState 
      };
    case RESET_SEARCH_RESULT:
      return {
        ...state,
        ...initialState
      }
    case GET_TOPIC_DATA:
      return {
        ...state, topicCardData: action.payload
      }
    case GET_SEARCH_SUGGESTIONS:
      return {
        ...state,
        searchSuggestionsData: action.payload
      }
    case GET_TOGGLE_DATA:
      return {
        ...state,
        toggleData: action.payload
      }
    case ADD_SELECTED_ASSETS_PILLS_COLLECTION :
      return {
        ...state,
        asstesPills: action.payload
      }
    case GET_API_RESPONSE_STATUS :
      return {
        ...state,
        apiStatus: action.payload
      }
    default:
      return state;
  }
};
export default searchResultsReducer;
